/**
 * BankStartDate — date de début de conciliation du compte : les écritures antérieures (soldes de départ, pièces déjà passées en banque
 * avant le premier relevé) ne sont pas considérées « en circulation ».
 */
import { useEffect, useState } from "react";
import { CalendarRange } from "lucide-react";
import { api } from "@/api";
import { toast } from "@/lib/toast";
import { Btn, errMsg, money } from "../../comptabilite/_shared";

export default function BankStartDate({ base, accountId, startDate, before, onSaved }) {
  const [v, setV] = useState(startDate || "");
  const [busy, setBusy] = useState(false);
  useEffect(() => { setV(startDate || ""); }, [startDate]);

  const save = async (val) => {
    setBusy(true);
    try { await api.put(`${base}/bank/settings`, { account_id: accountId, start_date: val || null }); toast.success(val ? `Début de conciliation : ${val}` : "Date de début retirée"); onSaved(); }
    catch (e) { toast.error(errMsg(e)); }
    finally { setBusy(false); }
  };

  return (
    <div className="flex items-center gap-2 flex-wrap text-xs px-3 py-2 bg-white border-t" data-testid="bank-start-date">
      <CalendarRange className="w-3.5 h-3.5 text-teal-700" />
      <label className="font-semibold text-slate-700">Début de conciliation</label>
      <input type="date" value={v} onChange={(e) => setV(e.target.value)} className="border border-slate-300 rounded-lg px-2 py-1 text-xs" data-testid="bank-start-date-input" />
      <Btn tone="slate" onClick={() => save(v)} busy={busy} disabled={(v || "") === (startDate || "")} testId="bank-start-date-save">Enregistrer</Btn>
      {startDate && <button onClick={() => save("")} className="text-slate-500 hover:underline" data-testid="bank-start-date-clear">Retirer</button>}
      <span className="text-slate-500 basis-full sm:basis-auto">
        {startDate
          ? <>Les écritures datées avant le <strong>{startDate}</strong> ne sont pas en circulation{before?.count ? <> — <strong data-testid="bank-before-start-count">{before.count}</strong> écriture(s) ignorée(s) ({money(before.total)})</> : ""}.</>
          : "Indiquez la date du premier relevé importé : les soldes de départ et les pièces antérieures ne compteront plus en circulation."}
      </span>
    </div>
  );
}
